import React, { useRef } from "react";

import { BASE_ASSETS_URL } from "constants/app";
import ErrorMessage from "components/errorMessage/errorMessage";

import styles from "./dragDropBrowseFileUpload.scss";

const FileUpload = ({
  label,
  helpTexts,
  value,
  name,
  onBlur,
  inputRef,
  onChange,
  progressValue, // get progressValue from onUploadProgress function of apiCall
  onFileNameClick,
  touched,
  errors,
  showAllErrors,
  errorClass,
  invalidFieldClass,
  disabled,
  accept,
  onDragLeave,
  onDragOver,
  onSampleClick,
}) => {
  const dragAreaRef = useRef();

  const renderHelpTexts = () => {
    if (helpTexts && helpTexts.length > 0) {
      return (
        <>
          {helpTexts.map((helpText, index) => (
            <li className={styles.helperTexts} key={index}>
              {helpText}
            </li>
          ))}
        </>
      );
    }
  };

  const onBrowse = () => inputRef.current?.click();

  const downloadFile = () => {
    const fileName = value[0].name.replace(/"/g, "");
    const blob = new Blob([value[0]]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.rel = "noopener";
    a.style = "display:none";
    a.href = url;
    a.target = "_blank";
    a.download = fileName;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  };

  const getPlaceHolderText = () => {
    return (
      <>
        {value?.length ? (
          <>
            {progressValue === 100 && <img  src={`${BASE_ASSETS_URL}images/check-icon.svg`} alt="Uploaded" />}{" "}
            <span title={value[0].name} className={styles.fileUploadedName} onClick={onFileNameClick ? onFileNameClick : downloadFile}>
              {value[0].name}
            </span>
            {!disabled && <span className={styles.close} onClick={onRemove}></span>}
          </>
        ) : (
          <>
            <img src={`${BASE_ASSETS_URL}images/upload.svg`} alt="Upload" />
            <span>
              {" "}
              Drop & Drag a file here or{" "}
              <a className={styles.browse} onClick={onBrowse}>
                Browse
              </a>
            </span>
          </>
        )}
      </>
    );
  };

  const onDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const newFiles = event.dataTransfer.files;
    onChange(newFiles);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onDragLeave();
  };
  
  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onDragOver();
  };

  const onRemove = () => {
    inputRef.current.value = "";
    onChange("");
  };

  return (
    <ErrorMessage
      {...{ errors, showAllErrors, errorClass, invalidFieldClass }}
      isErrorVisible={touched}
      renderChildren={(invalidFieldClass) => (
        <React.Fragment>
          <div
            className={`${styles.fileUploadNewSection} ${disabled && styles.disabled} ${errors?.length > 0 && styles.errors}`}
            ref={dragAreaRef}
            onDrop={(event) => onDrop(event)}
            onDragOver={(event) => handleDragOver(event)}
            onDragLeave={(event) => handleDragLeave(event)}
          >
            <div className={styles.upload_file}>
              <div className={styles.labelText}>
                <ul className={styles.fileInfoList}>
                  <li className={styles.fileLabel}>{label}</li>
                  {renderHelpTexts()}
                </ul>
              </div>
              <div className={styles.fileUploadArea}>{getPlaceHolderText()}</div>

              {progressValue && progressValue < 100 && (
                <div className={styles.progressWrapper}>
                  <div className={styles.progressBar}>
                    <div className={styles.progressLine} style={{ width: `${progressValue}%` }} />
                  </div>
                </div>
              )}
              <input
                ref={inputRef}
                type="file"
                id={name}
                required
                onChange={(e) => onChange(e.target.files)}
                onBlur={onBlur}
                files={value}
                accept={accept}
                hidden
              />
            </div>
            {onSampleClick && (
              <a onClick={onSampleClick} className={styles.sample_file}>
                <img src={`${BASE_ASSETS_URL}images/sample-file.png`} alt="Sample File" />
                <span className={styles.download_link}>Sample</span>
              </a>
            )}
          </div>
        </React.Fragment>
      )}
    />
  );
};

export default FileUpload;
